import { getSafeUrl } from "../../../utils/helpers.js";
import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./propertySearch.css";
import axios from "axios";
import slide3 from "@images/slide3.png";
import LocationSvg from "@images/location.svg";
import bed from "@images/Bed.svg";
import bathroom from "@images/Bathtub.svg";
import ruler from "@images/ruler.svg";
import miles from "@images/miles.png";
import heart from "@images/heart.svg";
import close from "@images/close-circle.svg";

import redheart from "@images/heart-red.svg";
import { useUserState } from "../../../Contexts/UserContext";
import HouseDummyImg from "../../../assets/images/houseDummy.webp";
import CustomPagination from "./CustomPagination";
import PropertyTypeFilter from "./PropertyTypeFilter ";
import PropertySearchMap from "./GoogleMapSelector";
import { Button, Modal } from "react-bootstrap";
import { se } from "date-fns/locale";

function PropertySearch() {
  const { user, isLoggedIn } = useUserState();
  const headers = {
    Authorization: user?.token,
  };
  const location = useLocation();
  const navigate = useNavigate();
  const addressRef = useRef(null);
  const locationSearch = new URLSearchParams(location.search);
  const [queryParams, setQueryParams] = useState({
    state: locationSearch.get("state") || "",
    type: locationSearch.get("type") || "",
    name: locationSearch.get("name") || "",
    amenities: locationSearch.get("amenities") || "",
    bedroom_no: locationSearch.get("bedroom_no") || "",
    bathroom_no: locationSearch.get("bathroom_no") || "",
    full_address: locationSearch.get("full_address") || "",
    minarea: locationSearch.get("minarea") || "",
    maxarea: locationSearch.get("maxarea") || "",
    minprice: locationSearch.get("minprice") || "",
    maxprice: locationSearch.get("maxprice") || "",
    page_no: locationSearch.get("page_no") || 1,
    house_type: locationSearch.get("house_type") || "",
    house_facility: locationSearch.get("house_facility") || "",
    sort: "",
    searchKey: locationSearch.get("searchKey") || "",
    lat: locationSearch.get("lat") || "",
    lng: locationSearch.get("lng") || "",
  });
  const [houseData, setHouseData] = useState([]);
  const [order, setOrder] = useState("");
  const [sortVal, setSortVal] = useState("");
  const [imageSrc, setImageSrc] = useState(heart);
  const [pageNo, setPageNo] = useState(locationSearch.get("page_no") || 1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage] = useState(12);
  const [isLoader, setIsLoader] = useState(false);
  const [allSelected, setAllSelected] = useState({});
  const [isFavorite, setIsFavorite] = useState({});
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [forceRecenter, setForceRecenter] = useState(0);
  const [mapLocation, setMapLocation] = useState(null);
  const DEFAULT_FILTERS = {
    amenities: "",
    bedroom_no: "",
    bathroom_no: "",
    minarea: "",
    maxarea: "",
    minprice: "",
    maxprice: "",
    house_type: "",
    house_facility: "",
    page_no: 1,
  };

  // Sync queryParams with URL params
  useEffect(() => {
    searchData(queryParams);
  }, []);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const updatedParams = { ...queryParams };

    // Update queryParams based on URL query
    Object.keys(updatedParams).forEach((key) => {
      if (searchParams.get(key)) {
        updatedParams[key] = searchParams.get(key);
      }
    });
    setQueryParams(updatedParams);
  }, [location.search]);

  const sortKey = (sortVal, order) => {
    let key = `${sortVal}${order}`;
    if (!sortVal) {
      key = order === "high" ? "high" : "low";
    }
    const updatedParams = { ...queryParams, sort: key, page_no: 1 };
    // setQueryParams((prev) => {
    //   return { ...prev, sort: key };
    // });
    setPageNo(1);
    setQueryParams(updatedParams);
    updateQueryParamsInURL(updatedParams);
    searchData(updatedParams);
  };

  const addFav = async (parameter) => {
    try {
      setIsFavorite((prevState) => ({
        ...prevState,
        [parameter]: !prevState[parameter], // Toggle the favorite status of the specific house ID
      }));
      const response = await axios.get(
        `${import.meta.env.VITE_APP_BASE_URL
        }/api/house/favorite-house/${parameter}`,
        {
          headers: headers,
        }
      );
      if (response) {
        if (response.data.message == true) {
          setImageSrc(redheart);
        } else {
          setImageSrc(heart);
        }
      }
      setIsLoader(false);
    } catch (error) {
      console.log(error);
      setIsLoader(false);
    }
  };
  const searchData = async (params = queryParams) => {
    const apiUrl = isLoggedIn
      ? `${import.meta.env.VITE_APP_BASE_URL
      }/api/search/propertySearchWithUserId`
      : `${import.meta.env.VITE_APP_BASE_URL}/api/search/propertySearch`;

    //alert(apiUrl);
    try {
      setIsLoader(true);
      let data = await axios.get(apiUrl, {
        headers: headers,
        params: params,
      });
      setHouseData([...data.data.results]);
      setTotalItems(data?.data?.totalResults);
      setIsLoader(false);
    } catch (error) {
      console.log(error);
      setIsLoader(false);
      return;
    }
  };
  useEffect(() => {
    if (houseData.length && isLoggedIn) {
      const favorites = Object.fromEntries(
        houseData.map((item) => [item.id, item.isFavorite])
      );
      setIsFavorite(favorites);
    }
  }, [houseData]);

  const updateQueryParamsInURL = (updatedParams) => {
    // Filter out any parameters with null, undefined, or empty string values
    const filteredParams = Object.keys(updatedParams)
      .filter(
        (key) =>
          updatedParams[key] !== null &&
          updatedParams[key] !== "" &&
          updatedParams[key] !== undefined
      )
      .reduce((obj, key) => {
        obj[key] = updatedParams[key];
        return obj;
      }, {});

    // Convert the filtered parameters to a query string
    const newSearchParams = new URLSearchParams(filteredParams).toString();

    // Update the URL with the new query string
    navigate({
      pathname: location.pathname,
      search: newSearchParams ? `?${newSearchParams}` : "", // Avoid adding `?` if there are no query params
    });
  };

  // Handle query parameter changes
  const handleChange = (key, value) => {
    const updatedParams = { ...queryParams, [key]: value, page_no: 1 };
    setPageNo(1);
    setQueryParams(updatedParams);
    updateQueryParamsInURL(updatedParams); // Update URL with new query params
    // setShowFilterModal(false);
  };

  useEffect(() => {
    const updatedParams = { ...queryParams, page_no: pageNo };
    setQueryParams(updatedParams); // Update queryParams with updatedParams
    updateQueryParamsInURL(updatedParams);
  }, [pageNo]); // Dependency array should track `page`

  const allSelectFunction = () => {
    const filteredParams = Object.keys(queryParams).reduce((obj, key) => {
      if (queryParams[key] === "") {
        obj[key] = true;
      } else {
        obj[key] = false;
      }
      return obj;
    }, {});
    return filteredParams;
  };

  // Call the searchData function whenever queryParams change
  // useEffect(() => {
  //   searchData();
  //   setAllSelected(allSelectFunction());
  // }, [queryParams]);

  // filter code
  const getCurrentFacilities = () => {
    return queryParams.house_facility
      ? queryParams.house_facility.split(",").filter(Boolean)
      : [];
  };

  const isAllSelected = () => {
    const facilities = getCurrentFacilities();
    return facilities.length === 2; // fully furnished + customize
  };

  const handleFacilityChange = (facility) => {
    const facilities = getCurrentFacilities();
    let newFacilities;

    if (facility === "all") {
      newFacilities = isAllSelected() ? [] : ["fully furnished", "customize"];
    } else {
      newFacilities = facilities.includes(facility)
        ? facilities.filter((f) => f !== facility)
        : [...facilities, facility];
    }

    handleChange("house_facility", newFacilities.join(","));
  };
  // google address input code
  useEffect(() => {
    if (!window.google || !addressRef.current) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      addressRef.current,
      {
        componentRestrictions: { country: "us" },
        fields: ["formatted_address", "geometry"],
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (!place.geometry) return; // invalid selection

      const newAddress = place.formatted_address;
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      // Update your state with full address + coordinates
      setQueryParams((prev) => ({
        ...prev,
        searchKey: newAddress,
        lat: lat,
        lng: lng,
      }));
    });
  }, []);
  const SearchHouse = () => {
    setForceRecenter((prev) => prev + 1);
    searchData();
    setAllSelected(allSelectFunction());
    setShowFilterModal(false);
  };
  const handleSearchClick = () => {
    setForceRecenter((prev) => prev + 1);
    searchData();
  };
  // debounce search on map location change
  useEffect(() => {
    if (!mapLocation) return;

    const timer = setTimeout(() => {
      const updatedParams = {
        ...queryParams,
        lat: mapLocation.lat,
        lng: mapLocation.lng,
        page_no: 1,
      };

      searchData(updatedParams);
    }, 700); // debounce delay

    return () => clearTimeout(timer);
  }, [mapLocation]);
  const clearAllFilters = () => {
    setQueryParams((prev) => {
      const updated = {
        ...prev,
        ...DEFAULT_FILTERS,
        page_no: 1,
      };
      setForceRecenter((prev) => prev + 1);
      searchData(updated);
      setShowFilterModal(false);
      return updated;
    });
  };

  return (
    <div>
      <div className="banner-section Dream-Home home_after_remove">
        <img src={slide3} alt="..." />

        <div className="my-container search-home">
          <div className="search-header">
            <h2>
              Find Your <span>Dream Home</span>
            </h2>
            <p>We’ve more than 745,000 apartments, place & plot.</p>
          </div>
          <div className="property-search search-form row">
            <div className="col-md-8">
              <div className="input-sec">
                <label className="form-label">
                  Location/House <span className="star_symb">*</span>
                </label>
                {queryParams.searchKey?.length > 0 ? (
                  <div
                    onClick={() =>
                      setQueryParams((prev) => ({
                        ...prev,
                        searchKey: "",
                      }))
                    }
                  >
                    <img src={close} />
                  </div>
                ) : (
                  <img src={LocationSvg} />
                )}
                <input
                  type="text"
                  className="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Enter your Desired Location"
                  value={queryParams.searchKey}
                  onChange={(e) => {
                    setQueryParams((prev) => ({
                      ...prev,
                      searchKey: e.target.value,
                    }));
                  }}
                  ref={addressRef}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="input-sec button-sec w-100">
                <button
                  className="handleSearchClick"
                  onClick={() => handleSearchClick()}
                >
                  Search
                </button>{" "}
              </div>
            </div>
            <div className="col-md-2">
              <div className="input-sec button-sec w-100">
                <button
                  className="handleSearchClick"
                  onClick={() => setShowFilterModal(true)}
                >
                  Filter
                </button>{" "}
              </div>
            </div>
            {/* <div
              className="input-sec button-sec"
              onClick={() => {
                setQueryParams((prev) => {
                  return { ...prev, searchKey: locSearch };
                });
              }}
            >
              <a>Search</a>
            </div> */}
          </div>
        </div>
      </div>

      <div className="all-property-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 loader-position">
              <div className="filter-sec">
                {houseData && houseData?.length > 0 ? (
                  <p>
                    Showing {(queryParams.page_no - 1) * itemsPerPage + 1}–
                    {Math.min(queryParams.page_no * itemsPerPage, totalItems)}{" "}
                    of {totalItems} results
                  </p>
                ) : (
                  <p></p>
                )}

                <div className="sort-sec">
                  <span>Order By Price:</span>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setOrder(e.target.value);
                      sortKey(sortVal, e.target.value);
                    }}
                  >
                    <option value="" selected>
                      -
                    </option>
                    <option value="high">High to Low</option>
                    <option value="low">Low to High</option>
                  </select>
                </div>
                {/* <div className="sort-sec">
                  <span>Sort by :</span>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setSortVal(e.target.value);
                      sortKey(e.target.value, order);
                    }}
                  >
                    <option value="" selected>
                      -
                    </option>
                    <option value="price">Price</option>
                    <option value="area">Area</option>
                    <option value="bed">Bedroom</option>
                    <option value="bath">Bathroom</option>
                  </select>
                </div> */}
              </div>
              <div className="row p-20 loader-box my-20 gx-3">
                {isLoader ? (
                  <div className="p-5 eye-loader-frame">
                    <div className="eye-loader-spinner"></div>
                  </div>
                ) : (
                  <>
                    {houseData?.length ? (
                      houseData.map((house, key) => {
                        return (
                          <div
                            key={key}
                            className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4"
                          >
                            <div className="property-listing">
                              <div className="property-sec">
                                <div className="property-inner">
                                  <span className="type-pro">
                                    {house.house_facility === "Customize"
                                      ? "Unfurnished"
                                      : house.house_facility}
                                  </span>
                                  <Link to={`/property_detail/${house.id}`}>
                                      <img
                                        src={
                                          getSafeUrl(house.images[house.images.length - 1])
                                        }
                                      onError={(e) => {
                                        e.target.src = HouseDummyImg;
                                      }}
                                    />
                                  </Link>
                                  <div className="property-content">
                                    <div className="property-discription">
                                      <a>
                                        <h4>{house.name}</h4>
                                        <p>{`${house.full_address} ${house.state} ${house.country} `}</p>
                                      </a>
                                    </div>
                                    <div className="property-price">
                                      <p className="pricing">
                                        ${house.monthly_price}/
                                        <span>Month</span>
                                      </p>

                                      {/* {isLoggedIn && (
                                        <a onClick={() => addFav(house.id)}>
                                          {/* Use a ternary operator to conditionally render the heart icon 
                                          {house.isFavorite ? (
                                            <img
                                              className="prop-Heart"
                                              style={{ height: "30px" }}
                                              src={redheart}
                                            />
                                          ) : (
                                            <img
                                              className="prop-Heart"
                                              src={
                                                house.isFavorite
                                                  ? redheart
                                                  : heart
                                              }
                                            />
                                          )}
                                        </a>
                                      )} */}
                                      <a
                                        className={`like-sec ${isFavorite[house.id] ? "like" : ""
                                          }`}
                                        onClick={() => {
                                          if (isLoggedIn) {
                                            addFav(house.id);
                                          } else {
                                            navigate("/login");
                                          }
                                        }}
                                      >
                                        <i className="fa fa-heart-o"></i>
                                      </a>
                                    </div>
                                    <div className="property-overview">
                                      <ul>
                                        <li>
                                          <img src={bed} /> {house.bedroom_no}{" "}
                                          Bedroom
                                        </li>
                                        <li>
                                          <img src={bathroom} />{" "}
                                          {house.bathroom_no} Bathroom
                                        </li>
                                        <li>
                                          <img src={ruler} /> {house.area} SQ FT
                                        </li>
                                        <li>
                                          <i
                                            class="fa-regular fa-map"
                                            style={{
                                              color: "rgb(4, 116, 186)",
                                              marginRight: "8px",
                                            }}
                                          ></i>{" "}
                                          {"  "}
                                          {house?.distance} miles
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="container">
                        <div className="d-flex row align-items-center h-100 justify-content-center p-20 my-20">
                          No data found
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 pe-0">
              <PropertySearchMap
                houses={houseData}
                centerLat={queryParams.lat}
                centerLng={queryParams.lng}
                forceRecenter={forceRecenter}
                onLocationChange={(lat, lng) => {
                  setQueryParams((prev) => ({
                    ...prev,
                    lat,
                    lng,
                    page_no: 1,
                  }));

                  setMapLocation({ lat, lng });
                }}
                addFav={addFav}
              />
            </div>
            {houseData?.length > 0 && (
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <CustomPagination
                  totalItems={+totalItems}
                  itemsPerPage={itemsPerPage}
                  currentPage={pageNo}
                  onPageChange={(page) => setPageNo(page)}
                  disabledPage={isLoader}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>Filter</Modal.Header>
        <Modal.Body>
          <div className="sidebar-listing">
            <div className="specialities-checkbox">
              {/* <div className="searcher-sec">
                    <h4>Find your home</h4>
                    <div className="form-group">
                      <input
                        type="Name"
                        className="form-control"
                        id="exampleFormControlInput1"
                        placeholder="What are you looking for?"
                        value={queryParams.name}
                        onChange={(e) => handleChange("name", e.target.value)}
                      />
                      <img src={search} />
                    </div>
                  </div> */}
            </div>
            <div className="specialities-checkbox">
              {/* <div className="listing-check">
                    <h4>Property Category</h4>
                    <div className="custom-checkbox custom-control">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="customCheck01"
                        checked={allSelected?.house_facility}
                        onChange={() => {
                          handleChange("house_facility", "");
                        }}
                      />
                      <label className="custom-control-label">All</label>
                    </div>
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="customCheck01"
                        checked={
                          queryParams["house_facility"] === "fully furnished" ||
                          allSelected?.house_facility
                        }
                        onChange={(e) => {
                          console.log(
                            e.target.checked,
                            queryParams["house_facility"]
                          );
                          if (e.target.checked) {
                            handleChange("house_facility", "fully furnished");
                          } else {
                            allSelected?.house_facility
                              ? handleChange("house_facility", "customize")
                              : handleChange("house_facility", "");
                          }
                        }}
                      />
                      <label className="custom-control-label">
                        Fully Furnished
                      </label>
                    </div>
                    <div className="custom-checkbox custom-control">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="customCheck02"
                        checked={
                          queryParams["house_facility"] === "customize" ||
                          allSelected?.house_facility
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            handleChange("house_facility", "customize");
                          } else {
                            allSelected?.house_facility
                              ? handleChange(
                                  "house_facility",
                                  "fully furnished"
                                )
                              : handleChange("house_facility", "");
                          }
                        }}
                      />
                      <label className="custom-control-label">
                        Customizable
                      </label>
                    </div>
                  </div> */}
              <div className="listing-check">
                <h4>Property Category</h4>

                {/* All Checkbox */}
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="customCheckAll"
                    checked={isAllSelected()}
                    onChange={() => handleFacilityChange("all")}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customCheckAll"
                  >
                    All
                  </label>
                </div>

                {/* Fully Furnished */}
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="customCheckFully"
                    checked={getCurrentFacilities().includes("fully furnished")}
                    onChange={() => handleFacilityChange("fully furnished")}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customCheckFully"
                  >
                    Fully Furnished
                  </label>
                </div>

                {/* Customizable */}
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="customCheckCustomize"
                    checked={getCurrentFacilities().includes("customize")}
                    onChange={() => handleFacilityChange("customize")}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customCheckCustomize"
                  >
                    Unfurnished
                  </label>
                </div>
              </div>

              <PropertyTypeFilter
                queryParams={queryParams}
                handleChange={handleChange}
              ></PropertyTypeFilter>
              <div className="listing-check">
                <h4>Price Range</h4>
                {/* <input
                      type="range"
                      className="form-range"
                      min="0"
                      max="5"
                      id="customRange2"
                    /> */}
                <div className="custom-price">
                  <input
                    type="Name"
                    className="form-control"
                    id="exampleFormControlInput1"
                    placeholder="$0"
                    value={queryParams.minprice}
                    onChange={(e) => handleChange("minprice", e.target.value)}
                  />
                  <i className="fa fa-minus"></i>
                  <input
                    type="Name"
                    className="form-control"
                    id="exampleFormControlInput1"
                    placeholder="$50000"
                    value={queryParams.maxprice}
                    onChange={(e) => handleChange("maxprice", e.target.value)}
                  />
                </div>
              </div>
              <div className="listing-check">
                <h4>Bedroom</h4>
                <div className="activity-sec date-slot">
                  <ul>
                    <li className="list-group-item">
                      <input
                        type="radio"
                        id="male"
                        onChange={() => handleChange("bedroom_no", "")}
                        name="bedroom_no"
                      />
                      <a className="">Any</a>
                    </li>
                    <li className="list-group-item">
                      <input
                        type="radio"
                        id="male"
                        name="bedroom_no"
                        checked={queryParams.bedroom_no === "1"}
                        onChange={() => handleChange("bedroom_no", 1)}
                      />
                      <a className="">1</a>
                    </li>
                    <li className="list-group-item">
                      <input
                        type="radio"
                        id="male"
                        name="bedroom_no"
                        checked={queryParams.bedroom_no === "2"}
                        onChange={() => handleChange("bedroom_no", 2)}
                      />
                      <a className="">2</a>
                    </li>
                    <li className="list-group-item">
                      <input
                        type="radio"
                        id="male"
                        name="bedroom_no"
                        checked={queryParams.bedroom_no === "3"}
                        onChange={() => handleChange("bedroom_no", 3)}
                      />
                      <a className="">3</a>
                    </li>
                    <li className="list-group-item">
                      <input
                        type="radio"
                        id="male"
                        name="bedroom_no"
                        checked={queryParams.bedroom_no === "4"}
                        onChange={() => handleChange("bedroom_no", 4)}
                      />
                      <a className="">4+</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="listing-check">
                <h4>Bathroom</h4>
                <div className="activity-sec date-slot">
                  <ul>
                    <li className="list-group-item">
                      <input
                        type="radio"
                        id="male"
                        name="bathroom_no"
                        onChange={() => handleChange("bathroom_no", "")}
                      />
                      <a className="">Any</a>
                    </li>
                    <li className="list-group-item">
                      <input
                        type="radio"
                        id="male"
                        checked={queryParams.bathroom_no === "1"}
                        name="bathroom_no"
                        onChange={() => handleChange("bathroom_no", 1)}
                      />
                      <a className="">1</a>
                    </li>
                    <li className="list-group-item">
                      <input
                        type="radio"
                        id="male"
                        name="bathroom_no"
                        checked={queryParams.bathroom_no === "2"}
                        onChange={() => handleChange("bathroom_no", 2)}
                      />
                      <a className="">2</a>
                    </li>
                    <li className="list-group-item">
                      <input
                        type="radio"
                        id="male"
                        name="bathroom_no"
                        checked={queryParams?.bathroom_no === "3"}
                        onChange={() => handleChange("bathroom_no", 3)}
                      />
                      <a className="">3</a>
                    </li>
                    <li className="list-group-item">
                      <input
                        type="radio"
                        id="male"
                        name="bathroom_no"
                        checked={queryParams?.bathroom_no === "4"}
                        onChange={() => handleChange("bathroom_no", 4)}
                      />
                      <a className="">4+</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="listing-check">
                <h4>Square Feet</h4>
                {/* <input
                      type="range"
                      className="form-range"
                      min="0"
                      max="5"
                      id="customRange2"
                      onChange={(e) =>
                        handleChange("bathroom_no", e.target.value)
                      }
                    /> */}
                <div className="custom-price">
                  <input
                    type="Name"
                    className="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Min."
                    value={queryParams?.minarea}
                    onChange={(e) => handleChange("minarea", e.target.value)}
                  />
                  <i className="fa fa-minus"></i>
                  <input
                    type="Name"
                    className="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Max"
                    value={queryParams?.maxarea}
                    onChange={(e) => handleChange("maxarea", e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => clearAllFilters()}>
            Clear
          </Button>
          <Button variant="secondary" onClick={() => SearchHouse()}>
            Search
          </Button>
          {/* <Button variant="danger" disabled={delLoader} onClick={handleDelete}>
            {delLoader ? <Spinner size="sm" /> : "Delete"}
          </Button> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PropertySearch;
